__turbopack_context__.v({
  "amount": "Z32BLW_amount",
  "name": "Z32BLW_name",
  "notes": "Z32BLW_notes",
});
